import graphql__f70cef2afad24b7855d0 from "./__generated__/ContributionModalTheme_contribution.graphql.js";import { graphql, useFragment } from "react-relay";
import classNames from "classnames";

import { themePathFor } from "../../Utils/themePathFor";
import Icon from "../../Utils/Icon";

const ContributionModalTheme = props => {
  const contribution = useFragment(
    ContributionModalTheme_contribution,
    props.contribution
  );
  const { theme } = contribution;

  const modalIconDivClassNames = classNames([
    "icon",
    "flex-shrink-0",
    "text-greater",
    "text-center",
    "mr-2"
  ]);

  const { rootTheme, subTheme, finalTheme } = themePathFor(theme);

  if (!rootTheme) return null;

  const modalIconClassNames =
    subTheme?.iconClass && classNames([subTheme.iconClass, "align-middle"]);

  return (
    <div className="contribution-modal-theme box theme margin-top-xs">
      <div
        style={{
          backgroundColor: rootTheme.primaryColor,
          color: rootTheme.primaryContrastColor
        }}
        className="name text-uppercase margin-bottom-xs"
      >
        {rootTheme.name}
      </div>

      {subTheme && (
        <div className="d-flex margin-bottom-xs align-items-center">
          {modalIconClassNames && (
            <div
              style={{
                backgroundColor: rootTheme.primaryColor,
                color: rootTheme.primaryContrastColor
              }}
              className={modalIconDivClassNames}
            >
              <Icon className={modalIconClassNames} />
            </div>
          )}

          <div className="topic">{subTheme.name}</div>
        </div>
      )}

      {finalTheme && (
        <div
          className="question box mb-2"
          style={{
            backgroundColor: rootTheme.primaryColor,
            color: rootTheme.primaryContrastColor
          }}
        >
          {finalTheme.name}
        </div>
      )}
    </div>
  );
};

const ContributionModalTheme_contribution = graphql__f70cef2afad24b7855d0;

export default ContributionModalTheme;
